export default function WorkshopCardSkeleton() {
  return (
    <article
      className="
        relative
        bg-white
        rounded-[32px]
        shadow-md
        md:h-[320px]
        xl:h-[360px]
        flex flex-col md:flex-row
        border
        overflow-visible
        workshop-article
        lg:mt-[40px]
        max-[767px]:overflow-hidden
        animate-pulse
      "
      style={{ borderColor: "#e5e7eb" }}
    >
      {/* MOBILE HEADER */}
      <div className="md:hidden flex items-center gap-2 px-3 pt-1">
        {/* Skeleton ribbon */}
        <div
          className="
          relative
          w-[120px] h-[161px]
          flex items-center justify-center
          overflow-hidden
          rounded-lg
          bg-gray-300
        "
        >
          <div className="relative w-[95px] h-[95px] rounded-[50%] bg-gray-400" />
        </div>

        {/* Skeleton text block */}
        <div className="flex-1 flex flex-col justify-between text-[11px] leading-snug gap-2 mt-[-4]">
          <div className="space-y-2">
            <div className="h-8 bg-gray-300 rounded w-3/4" />
          </div>
          <div className="flex flex-row gap-4">
            <div className="space-y-1 min-w-[50%]">
              <div className="h-4 bg-gray-300 rounded w-full" />
              <div className="h-6 bg-gray-300 rounded w-2/3" />
              <div className="h-3 bg-gray-300 rounded w-1/2" />
            </div>
            <div className="space-y-1">
              <div className="h-4 bg-gray-300 rounded w-full" />
              <div className="h-6 bg-gray-300 rounded w-2/3" />
              <div className="h-3 bg-gray-300 rounded w-1/2" />
            </div>
          </div>
        </div>
      </div>

      {/* DESKTOP RIBBON */}
      <div className="md:w-[145px] xl:w-[220px] hidden md:flex md:flex-col md:px-0">
        <div
          className="
            absolute
            top-[-2]
            w-[200px] md:left-4 2xl:left-8
            h-[400px]
            md:w-[140px] md:h-[370px]
            xl:w-[190px] xl:h-[425px]
            bg-gray-300
            rounded-lg
            flex flex-col items-center justify-start gap-3
            overflow-visible
        "
        >
          <div className="flex flex-col items-center gap-2 mt-3 w-[70%]">
            <div className="relative w-14 h-14 md:w-[100px] md:h-[100px] xl:w-[142px] xl:h-[142px] shrink-0 bg-gray-400 rounded-[50%]" />
            <div className="space-y-2 w-full">
              <div className="h-4 bg-gray-400 rounded w-full" />
              <div className="h-6 bg-gray-400 rounded w-3/4" />
            </div>
          </div>
        </div>
      </div>

      {/* CENTER CONTENT */}
      <div
        className="
        flex-1
        px-5
        md:px-6 md:py-2 lg:px-8 xl:px-1 2xl:px-8
        flex flex-col
        md:pr-[280px] lg:pr-[260px] xl:pr-[540px] 2xl:pr-[580px]
        max-h-[350px] md:max-h-[358px]
      "
      >
        <div className="flex-1 overflow-y-auto pr-2 mt-[px] mb-[18px] scroll-thin">
          <div className="min-h-full flex flex-col justify-center space-y-4">
            {/* Title skeleton */}
            <div className="h-12 bg-gray-300 rounded w-3/4 hidden md:block" />

            {/* Subtitle skeleton */}
            <div className="space-y-2">
              <div className="h-5 bg-gray-300 rounded w-full" />
              <div className="h-5 bg-gray-300 rounded w-4/5" />
            </div>

            {/* Description skeleton */}
            <div className="space-y-2">
              <div className="h-4 bg-gray-300 rounded w-full" />
              <div className="h-4 bg-gray-300 rounded w-full" />
              <div className="h-4 bg-gray-300 rounded w-3/4" />
            </div>

            {/* Button skeleton */}
            <div className="mt-4">
              <div className="h-11 bg-gray-300 rounded-full w-40" />
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT IMAGE SKELETON */}
      <div
        className="
          relative
          w-[98%]
          sm:w-[105%]
          sm:right-2
          right-0
          mx-auto
          mt-2
          xl:right-8
          h-[217px]
          rounded-[30px]
          overflow-hidden
          md:absolute md:top-1/2 md:right-2 md:-translate-y-1/2
          md:w-[257px] md:mx-0 md:mt-0 mb-1 sm:mb-4
          md:h-[360px] lg:h-[350px]
          xl:w-[506px] xl:h-[403px]
          bg-gray-300
      "
      />
    </article>
  );
}
